import { API_BASE, buildAuthHeaders } from "./base";

export const WORKSPACE_API_BASE = API_BASE;

export async function handleWorkspaceJson(
  response,
  fallback = "Request failed."
) {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const detail = data?.detail;
    const message =
      typeof detail === "string"
        ? detail
        : detail?.message || data?.message || fallback;
    const error = new Error(message);
    error.payload = data;
    error.status = response.status;
    throw error;
  }
  return data;
}

export function buildWorkspaceQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.set(key, String(value));
  });
  const serialized = query.toString();
  return serialized ? `?${serialized}` : "";
}

export async function workspaceRequest(path, options = {}) {
  const {
    method = "GET",
    token = null,
    body = undefined,
    headers = {},
    fallback = "Request failed.",
  } = options;
  let response;
  try {
    response = await fetch(`${WORKSPACE_API_BASE}${path}`, {
      method,
      headers: {
        ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
        ...buildAuthHeaders(token),
        ...headers,
      },
      credentials: "include",
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
  } catch (error) {
    const originalMessage = String(error?.message || "").trim();
    const isGenericNetworkError =
      !originalMessage ||
      /networkerror when attempting to fetch resource/i.test(originalMessage) ||
      /failed to fetch/i.test(originalMessage);
    const wrappedError = new Error(
      isGenericNetworkError ? fallback : `${fallback} ${originalMessage}`
    );
    wrappedError.cause = error;
    throw wrappedError;
  }
  return handleWorkspaceJson(response, fallback);
}
